import {
  datetimeSorter,
  objectSorter,
} from '@/helpers/sorting'

export const logTypes = {
  none: {
    value: 'None',
    text: '',
    icon: '',
    color: '',
  },
  info: {
    value: 'Info',
    text: 'Info',
    icon: 'info',
    color: 'info',
  },
  warn: {
    value: 'Warning',
    text: 'Warning',
    icon: 'warning',
    color: 'warning',
  },
  error: {
    value: 'Error',
    text: 'Error',
    icon: 'error',
    color: 'error',
  },
  success: {
    value: 'Success',
    text: 'Success',
    icon: 'done',
    color: 'success',
  },
}

export const logTypesIndexByValue = {
  0: logTypes.none,
  1: logTypes.info,
  2: logTypes.warn,
  3: logTypes.error,
  4: logTypes.success,
}

export function groupLogsByProcessInstanceId(ingestionResults) {
  let group = makeReverseKeys(ingestionResults.slice())

  ingestionResults.forEach(function(x) {
    let key = getLogPIID(x)
    group[key].push(x)
  })

  Object.keys(group).forEach(function(x) {
    group[x].sort(objectSorter('created_at', datetimeSorter))
    group[x] = group[x].reverse()
  })

  return group
}

function makeReverseKeys(ingestionResults) {
  let group = {}
  ingestionResults.reverse().forEach(function(x) {
    let key = getLogPIID(x)
    if (!group[key]) {
      group[key] = []
    }
  })
  return group
}

function getLogPIID(ingestionResult) {
  let key = ingestionResult.executionId
  if (key == null || key == undefined || !key || key == '00000000-0000-0000-0000-000000000000') {
    key = 'unknown'
  }
  return key
}